import { useExperimentFlag } from '@zenbusiness/application-commons-experiments';

import { ENABLE_DASHBOARD_CAROUSEL } from '#client/constants/experimentsFlags';

import Carousel from './Carousel';

function CarouselGateway() {
  const enableCarousel = useExperimentFlag(ENABLE_DASHBOARD_CAROUSEL, false);

  if (!enableCarousel) {
    return null;
  }

  return <Carousel />;
}

export default CarouselGateway;
